module.exports = __webpack_public_path__ + "img/1537379922.12a39a80.jpg";